<template>
<div class="chapter">
<div class="inner_page">
<p class="C246"><a id="page_vii"><em>Contents</em></a></p><a id="page_vii">
</a><p class="C236"><a id="page_vii"></a><a href="#/xhtml/05_Acknowle#page_ix">ACKNOWLEDGMENTS</a></p>
<p class="C237"><a href="#/xhtml/06_Introduc#page_1"><em>Introduction</em>. CONSTRUCTING DIFFICULT REPUTATIONS</a></p>
<p class="C237"><span href="#/xhtml/07_One__Ben#page_32" title="Link target outside of Sample"><em>One</em>. BENEDICT ARNOLD AND THE COMMEMORATION OF TREASON</span></p>
<p class="C237"><span href="#/xhtml/08_Two__War#page_60" title="Link target outside of Sample"><em>Two</em>. WARREN HARDING AND THE MEMORY OF INCOMPETENCE</span></p>
<p class="C237"><span href="#/xhtml/09_Three__J#page_95" title="Link target outside of Sample"><em>Three</em>. JOHN BROWN AND THE LEGITIMATION OF POLITICAL VIOLENCE</span></p>
<p class="C237"><span href="#/xhtml/10_Four__Fa#page_130" title="Link target outside of Sample"><em>Four</em>. FATTY ARBUCKLE AND THE CREATION OF PUBLIC ATTENTION</span></p>
<p class="C237"><span href="#/xhtml/11_Five__He#page_167" title="Link target outside of Sample"><em>Five</em>. HENRY FORD AND THE MULTIPLE-AUDIENCE PROBLEM</span></p>
<p class="C237"><span href="#/xhtml/12_Six__Vla#page_195" id="page_viii" title="Link target outside of Sample"><em>Six</em>. VLADIMIR NABOKOV, LOLITA, AND THE CREATION OF IMAGINARY SOCIAL RELATIONS</span></p>
<p class="C237"><span href="#/xhtml/13_Seven__H#page_210" title="Link target outside of Sample"><em>Seven</em>. HERMAN MELVILLE AND THE DEMISE OF LITERARY REPUTATION</span></p>
<p class="C237"><span href="#/xhtml/14_Eight__S#page_232" title="Link target outside of Sample"><em>Eight</em>. SINCLAIR LEWIS, <em>MAIN STREET</em>, AND COMMUNITY REPUTATION</span></p>
<p class="C236"><span href="#/xhtml/15_Conclusi#page_259" title="Link target outside of Sample"><em>Conclusion</em>. DIFFICULT REPUTATIONS</span></p>
<p class="C237"><span href="#/xhtml/notes" title="Link target outside of Sample">NOTES</span></p>
<p class="C236a"><span href="#/xhtml/16_Index#page_263" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?6d62803e